var MTGGoldfish = MTGGoldfish || {};
MTGGoldfish.onDocumentReadyArray = MTGGoldfish.onDocumentReadyArray || [];
MTGGoldfish.onDocumentReadyArray.push(function() { 

  console.log("scryfall");
  $(".scryfall-mapping-rules-container").sortable();
});
console.log("scryfall outside");
